import React from "react";
import CommonSettingTable from "./CommonSettingTable";
import { useDispatch, useSelector } from "react-redux";
import { showCommonSetting } from "../../../redux/actions";
import { responseSetting } from "../../../redux/reducers";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";

export default function CommonSetting() {
  const dispatch = useDispatch();
  const { common } = useSelector(responseSetting);
  const { user } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (user) {
      if (user.Queryable !== "queryable_special@123") {
        history.push("/home");
        return;
      }
    }
  }, [history, user]);

  React.useEffect(() => {
    dispatch(showCommonSetting());
  }, [dispatch]);

  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>CommonSetting</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>CommonSetting</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <CommonSettingTable dataSource={common} />
        </div>
      </div>
    </>
  );
}
